import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { MailConfig } from '../../configuration/mailconfig/mailconfig';
let header = new HttpHeaders();
header = header.set('Content-Type', 'application/json; charset=utf-8');
@Injectable({
  providedIn: 'root'
})
export class NewsletterService {

  constructor(private httpClient: HttpClient) { }
  baseUrl: string = environment.serviceUrl;

  //httpclient get method
  Get(): Observable<MailConfig[]> {
    return this.httpClient.get<MailConfig[]>(this.baseUrl + 'api/MailConfigApi/');
  };

  //httpclient method to get the mail config info for the given id/name
  Getbyinfo(_mailConfigModel: MailConfig): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/MailConfigApi/GetById', _mailConfigModel, { headers: header, observe: 'response' });
  }

  Getbyinfonewsletter(): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/MailConfigApi/Getbyinfonewsletter');
  }

  Getformdetailsfornewsletter(dbid: string, dbname: string, formconfigid: string): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/MailConfigApi/Getformdetailsfornewsletter/' + dbid + '/' + dbname + '/' + formconfigid, formconfigid);
  }
  //httpclient put method
  Put(_mailConfigModel: MailConfig): Observable<any> {
    return this.httpClient.put<any>(this.baseUrl + 'api/MailConfigApi/sendnewsletter', _mailConfigModel,
      { headers: header, observe: 'response' });
  }
 
}
